import { jsxs, jsx } from "react/jsx-runtime";
import { useColors } from "@inbody/core";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
function SectionHeading(props) {
  const { icon, title } = props;
  const { brand } = useColors();
  return /* @__PURE__ */ jsxs(
    Stack,
    {
      direction: "row",
      spacing: 0.75,
      alignItems: "center",
      mb: 1.25,
      sx: { color: brand[600], "& svg": { fontSize: 16 } },
      children: [
        icon,
        /* @__PURE__ */ jsx(Typography, { variant: "caption", fontWeight: 700, children: title })
      ]
    }
  );
}
export {
  SectionHeading
};
